import { render, staticRenderFns } from "./prepaidCardStatList.vue?vue&type=template&id=270108a0&scoped=true&"
import script from "./prepaidCardStatList.vue?vue&type=script&lang=js&"
export * from "./prepaidCardStatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270108a0",
  null
  
)

export default component.exports